export const HEAP_SCRIPT_ID = 'heapScript';

export declare type Heap = {
  track: (event: string, properties?: object) => void;
  identify: (identity: string) => void;
  resetIdentity: () => void;
  addUserProperties: (properties: object) => void;
  addEventProperties: (properties: object) => void;
  removeEventProperty: (property: string) => void;
  clearEventProperties: () => void;
  load: (appId: string, isSsl: boolean) => void;
};
